var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModuleReservations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-ea77e0f2-a624-43b0-bade-9b5e297b633f",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.19,
    height: 13.03,
    viewBox: "0 0 13.19 13.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-d0d43060-78bd-4d9f-afdd-f9a80d8a74bd",
    "data-name": "Object"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.01,13.03H.18c-.1,0-.18-.08-.18-.18V1.55c0-.1.08-.18.18-.18h12.83c.1,0,.18.08.18.18v11.3c0,.1-.08.18-.18.18ZM.36,12.67h12.47V1.73H.36v10.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84,2.7c-.1,0-.18-.08-.18-.18V.18c0-.1.08-.18.18-.18s.18.08.18.18v2.34c0,.1-.08.18-.18.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25,2.7c-.1,0-.18-.08-.18-.18V.18c0-.1.08-.18.18-.18s.18.08.18.18v2.34c0,.1-.08.18-.18.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.42,9.67v-.26c.08-.07.2-.18.36-.31.16-.14.28-.24.37-.32.09-.07.2-.17.33-.3.14-.13.24-.23.32-.31s.16-.18.26-.3c.09-.12.17-.22.22-.31.11-.22.17-.44.17-.66s-.06-.4-.19-.55c-.13-.15-.33-.23-.61-.23s-.49.08-.64.25c-.15.17-.23.38-.24.65h-.35c.02-.39.14-.69.36-.9.22-.21.5-.32.85-.32s.63.1.85.3.32.47.32.83c0,.16-.03.32-.1.49-.06.17-.14.32-.22.44-.08.13-.2.27-.35.44-.15.16-.28.29-.37.38-.09.09-.23.21-.41.37-.18.16-.3.26-.35.31h1.92v.32h-2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31,6c.23-.17.51-.25.86-.25s.62.09.82.28c.2.19.31.42.31.71,0,.2-.06.38-.18.54-.12.16-.28.27-.48.33v.03c.23.06.4.18.53.36.13.18.19.42.19.71s-.1.54-.31.74c-.21.2-.5.3-.87.3s-.67-.09-.91-.28c-.23-.19-.37-.45-.4-.78h.35c.02.21.12.39.29.53.17.14.39.21.67.21s.49-.07.63-.22c.15-.15.22-.34.22-.57,0-.31-.1-.53-.3-.66-.2-.13-.49-.19-.89-.19h-.12v-.31h.12c.73,0,1.1-.24,1.1-.7,0-.22-.07-.39-.21-.52-.14-.13-.33-.19-.59-.19s-.46.05-.61.16c-.15.11-.24.26-.27.47h-.36c.04-.29.17-.53.39-.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.01,3.5H.31c-.1,0-.18-.08-.18-.18s.08-.18.18-.18h12.7c.1,0,.18.08.18.18s-.08.18-.18.18Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleReservations);
export default __webpack_public_path__ + "static/media/icon_module_reservations.3d413413b7a7f1f8c948b675556ba202.svg";
export { ForwardRef as ReactComponent };